import { render, staticRenderFns } from "./PlantRemarksData.vue?vue&type=template&id=a933cf18&"
import script from "./PlantRemarksData.vue?vue&type=script&lang=ts&"
export * from "./PlantRemarksData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports